import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { useLanguage } from "../i18n/translations";

export const Footer = () => {
  const { t } = useLanguage();

  const links = [
    { href: "#services", label: t.nav.services },
    { href: "#surya-ghar", label: t.nav.scheme },
    { href: "#equipment", label: t.nav.equipment },
    { href: "#contact", label: t.nav.contact },
  ];

  return (
    <footer className="border-t border-white/10 bg-navy-900/60">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-4">
            <Logo size={64} />
            <div className="text-sm text-slate-400">{t.footer.tagline}</div>
          </div>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-eco/40 bg-eco/10 px-4 py-2 text-xs font-semibold text-eco-soft">
            <ShieldCheck size={14} /> {t.footer.vendor}
          </div>
          <div className="mt-5 flex gap-3">
            {[Facebook, Instagram, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#top"
                aria-label="Social link"
                data-testid={`footer-social-${i}`}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-slate-400 transition-colors duration-200 hover:border-solar/50 hover:text-solar-yellow"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-slate-500">{t.footer.quickLinks}</h4>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-slate-400 transition-colors duration-200 hover:text-solar-yellow" data-testid={`footer-link-${l.href.slice(1)}`}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-slate-500">{t.footer.contact}</h4>
          <ul className="space-y-4 text-sm text-slate-300">
            <li className="flex items-center gap-3">
              <Phone size={15} className="shrink-0 text-solar-yellow" />
              <a href="tel:+918922004004" className="font-mono transition-colors hover:text-solar-yellow" data-testid="footer-phone">+91 89220 04004</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={15} className="shrink-0 text-solar-yellow" />
              <a href="mailto:enterprises.uma08@gmail.com" className="min-w-0 [overflow-wrap:anywhere] transition-colors hover:text-solar-yellow" data-testid="footer-email">enterprises.uma08@gmail.com</a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={15} className="shrink-0 text-solar-yellow" />
              <span>{t.footer.address}</span>
            </li>
            <li className="pt-2">
              <span className="text-xs uppercase tracking-wider text-slate-500">GSTIN</span>
              <div className="font-mono text-sm font-bold text-slate-200" data-testid="footer-gstin">09AHTPU9413H1ZJ</div>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 border-t border-white/10 px-4 py-6 text-center text-xs text-slate-500">
        <span>© 2026 {t.footer.rights}</span>
        <a href="/admin" className="transition-colors hover:text-solar-yellow" data-testid="footer-admin-link">Owner Login</a>
      </div>
    </footer>
  );
};
